import "../Amc/ApprovedTask.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Amc/ReadyTaskForPosting.css";
import active from "../Components/Assets/Admin-Assets/green-active.png";
import targetactive from "../Components/Assets/Admin-Assets/red-active.png";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";
import { formatFeedbackText } from "../utils/feedbackFormatter";

export function ReadyTaskForPosting() {
  const navigate = useNavigate();
  const [approvedCompanies, setApprovedCompanies] = useState([]);
  const [selectedApprovedTask, setSelectedApprovedTask] = useState(null);
  const [showSelectedTaskWindow, setShowSelectedTaskWindow] = useState(false);
  const [showApprovedTaskGrid, setShowApprovedTaskGrid] = useState(true);
  const [adminPostComment, setAdminPostComment] = useState("");

  const fetchCompanyAllDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to access this page.");
        navigate("/admin/login");
        return;
      }

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/all-companies",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        console.log("Successfull fetch Approved Task Section-6");
        const approvedCompanies = response.data
          .map((company) => ({
            ...company,
            tasks: company.tasks.filter(
              (task) => task.currentStatus === "Approved"
            ),
          }))
          .filter((company) => company.tasks.length > 0);

        if (approvedCompanies.length > 0) {
          setApprovedCompanies(approvedCompanies);
        } else {
          console.log("No Task Found");
        }
      } else {
        toast.error("Failed to fetch company profile");
      }
    } catch (error) {
      console.error("Error fetching company profile:", error);
      toast.error("An error occurred while fetching company details.");
      navigate("/admin/login");
    }
  };

  useEffect(() => {
    fetchCompanyAllDetails();
  }, []);
  const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  const isTodayOrPast = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    return date <= today;
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return {
          backgroundColor: "#5eb35eb7",
        };
      case "Pending":
        return {
          backgroundColor: "rgba(255, 145, 0, 0.69)",
        };
      case "Roll Back":
        return {
          backgroundColor: "rgba(245, 65, 0, 0.69)",
        };
      case "Posted":
        return {
          backgroundColor: "rgba(172, 5, 255, 0.76)",
        };
      default:
        return {};
    }
  };

  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // yyyy-mm-dd format
  };
  function getDaysDifference(dateString) {
    if (!dateString) return "-";
    const today = new Date();
    const target = new Date(dateString);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    return diffDays > 0 ? `${diffDays} Days` : `${Math.abs(diffDays)} Days Ago`;
  }

  return (
    <>
      <div className="admin-approved-task-container">
        {showApprovedTaskGrid && (
          <div className="approved-task-row-container">
            {approvedCompanies.map((company) =>
              company.tasks
                .filter((task) => isTodayOrPast(task.targetPostingDate))
                .map((task) => (
                  <div
                    className="grid-task-row-box"
                    onClick={() => {
                      setSelectedApprovedTask(task);
                      setShowSelectedTaskWindow(true);
                      setShowApprovedTaskGrid(false);
                    }}
                    key={task._id}
                  >
                    <div className="cmpy-id-status">
                      <div className="cmpy-task-id">
                        <h5>TaskId: </h5>
                        <p>#{task.taskId}</p>
                      </div>
                      <div
                        className="status-card-text"
                        style={getStatusClass(task.currentStatus)}
                      >
                        {isToday(task.targetPostingDate) ? (
                          <span style={{}}>Today</span>
                        ) : (
                          <span
                            style={{
                              color: "rgb(255, 255, 255)",
                              borderRadius: "6px",
                              fontWeight: "500",
                              fontSize: "19px",
                            }}
                          >
                            Over Date
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="cmpy-task-title">
                      <h5>Title: </h5>
                      <p className="overflow-control">{task.title}</p>
                    </div>
                    <div className="cmpy-task-review-date">
                      <h5>Review Date: </h5>
                      <p>
                        {new Date(
                          task.submissionForReview
                        ).toLocaleDateString()}
                      </p>
                    </div>
                    <div className="cmpy-task-review-date">
                      <h5
                        style={{
                          color: "#ff0000",
                        }}
                      >
                        Target Date:{" "}
                      </h5>
                      <p
                        style={{
                          color: "#ff0000",
                        }}
                      >
                        {new Date(task.targetPostingDate).toLocaleDateString()}
                      </p>
                    </div>
                    <div className="total-days">
                      <div className="submission-days">
                        <img src={active} alt="" />
                        Submission:{" "}
                        <p>{getDaysDifference(task.submissionForReview)}</p>
                      </div>
                      <div className="target-days">
                        <img src={targetactive} alt="" />
                        Target:{" "}
                        <p>{getDaysDifference(task.targetPostingDate)}</p>
                      </div>
                    </div>
                    <div className="cmpy-task-view-btn-container">
                      <div className="cmpy-task-view-btn">View</div>
                    </div>
                  </div>
                ))
            )}
          </div>
        )}

        {showSelectedTaskWindow && selectedApprovedTask && (
          <div className="admin-show-task-status-container">
            <div className="close-button-row">
              <img
                onClick={() => {
                  setShowSelectedTaskWindow(false);
                  setShowApprovedTaskGrid(true);
                }}
                width="48"
                height="48"
                src="https://img.icons8.com/fluency/48/delete-sign.png"
                alt="delete-sign"
                className="status-cross-symbol"
              />
            </div>

            <div className="status-top-floor">
              <div className="status-top-floor-row-1">
                <div className="status-col-1">
                  <div className="status-row rm-padding">
                    <div className="status-task-id">
                      <div className="task-id">Task ID</div>
                      <div className="task-id-number">
                        #{selectedApprovedTask.taskId}
                      </div>
                    </div>
                    <div
                      className="task-current-status"
                      style={getStatusClass(selectedApprovedTask.currentStatus)}
                    >
                      {selectedApprovedTask.currentStatus}
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Task Title</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.title}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Tagline or Slogan</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.tagline}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Purpose/Objective</div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.taskpurpose}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Main Headline</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.headline}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Key Offer or Message
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.offerormessage}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Call to Action (CTA)
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.calltoaction}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Branding Guidelines
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.guidlines}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Additional Information
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.additionalinfo}
                      </div>
                    </div>
                    <div className="status-task-des">
                      <div className="task-title-status">Task Description</div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.description}
                      </div>
                    </div>
                    <div className="for-date-row">
                      <div className="status-task-dates">
                        <label className="task-title-status">Target Date</label>
                        <div className="status-target-date">
                          <input
                            type="date"
                            name="targetPostingDate"
                            value={formatDateForDisplay(
                              selectedApprovedTask.targetPostingDate
                            )}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="status-task-dates">
                        <label className="task-title-status">
                          Deadline Date
                        </label>
                        <div className="status-deadline-date">
                          <input
                            type="date"
                            name="submissionForReview"
                            value={formatDateForDisplay(
                              selectedApprovedTask.submissionForReview
                            )}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="platform-row-response">
                      <label className="new-task-date-label">
                        Selected Platforms has to Post:
                      </label>
                      <div className="social-checkbox">
                        {selectedApprovedTask.platform_x && (
                          <img src={x} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_fb && (
                          <img src={fb} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_insta && (
                          <img src={insta} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_li && (
                          <img src={li} className="checkbox__textwrapper" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {selectedApprovedTask.currentStatus === "Roll Back" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index, arr) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {/* Only render numbered feedback when there is non-empty text */}
                                {(feedback?.feedback ?? "").toString().trim()
                                  .length > 0 && (
                                  <div className="feed-index">
                                    {arr.length > 1 ? (
                                      <div className="feedback-number">
                                        {index + 1})
                                      </div>
                                    ) : null}
                                    <div className="feedback-text">
                                      {formatFeedbackText(
                                        feedback.feedback,
                                        `ready-rollback-feedback-${index}`
                                      )}
                                    </div>
                                  </div>
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="admin-upload-image">
                      <label htmlFor="referenceimage">Upload Task Image:</label>
                      <input
                        type="file"
                        name="adminuploadtaskimage"
                        className="img-input admin-input"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSelectedFile(file);
                          if (file) {
                            const preview = URL.createObjectURL(file);
                            setPreviewUrl(preview);
                          }
                        }}
                      />
                      <button
                        className="button-uploade"
                        disabled={!selectedFile || isUploading}
                        onClick={async () => {
                          if (!selectedApprovedTask || !selectedFile) return;

                          const formData = new FormData();
                          formData.append("image", selectedFile);

                          try {
                            setIsUploading(true);
                            const token = localStorage.getItem("token");

                            const response = await axios.post(
                              `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedApprovedTask._id}`,
                              formData,
                              {
                                headers: {
                                  "Content-Type": "multipart/form-data",
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            );

                            if (response.status === 200) {
                              toast.success(
                                "Task image uploaded successfully",
                                {
                                  autoClose: 500,
                                }
                              );
                              setShowTaskpreview(true);
                              setSelectedRolledBackTask((prev) => ({
                                ...prev,
                                referenceImage: response.data.task.image,
                              }));
                              setSelectedFile(null);
                            } else {
                              setShowTaskpreview(false);
                              toast.error("Image upload failed");
                            }
                          } catch (err) {
                            toast.error(
                              "Error uploading image: " + err.message
                            );
                          } finally {
                            setIsUploading(false);
                          }
                        }}
                      >
                        <span className="text">
                          {isUploading ? "Uploading..." : "Upload"}
                        </span>
                      </button>
                    </div>
                    <div className="status-col-2">
                      {previewUrl && (
                        <img
                          src={previewUrl}
                          className="yet-task-preview-img"
                          alt="Task Preview"
                        />
                      )}
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Approved" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                <div className="feed-index">
                                  <div className="feedback-number">
                                    {index + 1})
                                  </div>
                                  <div className="feedback-text">
                                    {formatFeedbackText(
                                      feedback.feedback,
                                      `ready-approved-feedback-${index}`
                                    )}
                                  </div>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="task-preview-img-container">
                      <div className="status-title-preview">
                        Approved Task Image
                      </div>
                      <img
                        src={selectedApprovedTask.doneTaskImage}
                        className="yet-task-preview-img admin-img-btm"
                        alt="Task Preview"
                      />
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Pending" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="admin-past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                <p className="feed-index">{index + 1}.</p>
                                <p>{feedback.feedback}</p>
                              </li>
                            )
                          )}
                        </ul>
                        <div className="task-preview-img-container">
                          <img
                            src={selectedApprovedTask.doneTaskImage}
                            className="yet-task-preview-img admin-img-btm"
                            alt="Task Preview"
                          />
                        </div>
                      </div>
                    )}
                    {selectedApprovedTask.doneTaskImage && (
                      <div className="task-preview-img-container">
                        <div className="status-title-preview">
                          Last Admin Uploaded Image
                        </div>
                        <img
                          src={selectedApprovedTask.doneTaskImage}
                          className="yet-task-preview-img admin-img-btm"
                          alt="Task Preview"
                        />
                      </div>
                    )}
                    <div className="admin-upload-image">
                      <label htmlFor="referenceimage">Upload Task Image:</label>
                      <input
                        type="file"
                        name="adminuploadtaskimage"
                        className="img-input admin-input"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSelectedFile(file);
                          if (file) {
                            const preview = URL.createObjectURL(file);
                            setPreviewUrl(preview);
                          }
                        }}
                      />
                      <button
                        className="button-uploade"
                        disabled={!selectedFile || isUploading}
                        onClick={async () => {
                          if (!selectedApprovedTask || !selectedFile) return;

                          const formData = new FormData();
                          formData.append("image", selectedFile);

                          try {
                            setIsUploading(true);
                            const token = localStorage.getItem("token");

                            const response = await axios.post(
                              `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedApprovedTask._id}`,
                              formData,
                              {
                                headers: {
                                  "Content-Type": "multipart/form-data",
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            );

                            if (response.status === 200) {
                              toast.success(
                                "Task image uploaded successfully",
                                {
                                  autoClose: 500,
                                }
                              );
                              setShowTaskpreview(true);
                              setSelectedRolledBackTask((prev) => ({
                                ...prev,
                                referenceImage: response.data.task.image,
                              }));
                              setSelectedFile(null);
                            } else {
                              setShowTaskpreview(false);
                              toast.error("Image upload failed");
                            }
                          } catch (err) {
                            toast.error(
                              "Error uploading image: " + err.message
                            );
                          } finally {
                            setIsUploading(false);
                          }
                        }}
                      >
                        <span className="text">
                          {isUploading ? "Uploading..." : "Upload"}
                        </span>
                      </button>
                    </div>
                    <div className="status-col-2">
                      {previewUrl && (
                        <img
                          src={previewUrl}
                          className="yet-task-preview-img"
                          alt="Task Preview"
                        />
                      )}
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Posted" && (
                  <>
                    {" "}
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                <div className="feed-index">
                                  <div className="feedback-number">
                                    {index + 1})
                                  </div>
                                  <div className="feedback-text">
                                    {formatFeedbackText(
                                      feedback.feedback,
                                      `ready-posted-feedback-${index}`
                                    )}
                                  </div>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="status-col-2">
                      {selectedApprovedTask.doneTaskImage && (
                        <div className="task-preview-img-container">
                          <div className="status-title-preview">
                            Posted Image
                          </div>
                          <img
                            src={selectedApprovedTask.doneTaskImage}
                            className="yet-task-preview-img admin-img-btm"
                            alt="Check Code"
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div className="new-task-row-input">
                  <label htmlFor="title">Admin Post Comment:</label>
                  <input
                    type="text"
                    name="adminPostComment"
                    className="new-task-title"
                    placeholder="Enter admin comment before launching"
                    value={adminPostComment}
                    onChange={(e) => setAdminPostComment(e.target.value)}
                  />
                </div>
                {/* <div className="admin-post-comment">
                  <input
                    type="text"
                    name="adminPostComment"
                    id="adminPostComment"
                    value={adminPostComment}
                    onChange={(e) => setAdminPostComment(e.target.value)}
                    placeholder="Enter admin comment before launching"
                  />
                </div> */}
                <div className="launch-btn-container">
                  <button
                    className="launch-task-btn"
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem("token");
                        await axios.put(
                          `${process.env.REACT_APP_API_URL}/task/update-task/${selectedApprovedTask._id}`,
                          {
                            currentStatus: "Posted",
                            adminPostComment: adminPostComment, // send comment
                          },
                          { headers: { Authorization: `Bearer ${token}` } }
                        );
                        toast.success("Task status set to Posted!");
                        setSelectedApprovedTask({
                          ...selectedApprovedTask,
                          currentStatus: "Posted",
                          adminPostComment: adminPostComment, // update local state
                        });
                        setAdminPostComment(""); // clear input
                        fetchCompanyAllDetails();
                      } catch (err) {
                        console.error(
                          "Launch error:",
                          err.response ? err.response.data : err
                        );
                        toast.error("Failed to launch task.");
                      }
                    }}
                    disabled={selectedApprovedTask.currentStatus === "Posted"}
                  >
                    {selectedApprovedTask.currentStatus === "Posted"
                      ? "Launched"
                      : "Launch"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={true}
        transition={Zoom}
      />
    </>
  );
}
 